import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "state-dot" }

import { StateColor, stateColorCssVar } from '@shell/utils/style';
import { computed } from 'vue';

interface Props {
    color: StateColor;
    size?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    color: {},
    size: { default: '8px' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v429379d1": (props.size),
  "v00ae23fa": (backgroundColor.value)
}))

const props = __props;
const backgroundColor = computed(() => stateColorCssVar(props.color));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})